import convertToNestedAttributes from './convert-to-nested-attributes'
import addSchoolYearToParams from './add-school-year-to-params'
import toHasManyAttribute from './to-has-many-attribute'
import mapAllocations from './map-allocations'
import { flow, omit } from 'lodash'
import { update, get, set } from 'lodash/fp'

// Keys from the API response that should not be processed by mapAllocations.
// `badges` are handled as individual top-level boolean fields.
const NON_SERIALIZABLE_KEYS = ['badges']

function setDistrictFunding(partner) {
  const funding = get('detail.districtFunding', partner)
  if (!funding) return partner
  return set(
    'detail.districtFunding',
    Number(funding.fractional) / 100,
    partner
  )
}

function serializePartnerParams(partner, schoolYear) {
  return flow(
    (params) => omit(params, NON_SERIALIZABLE_KEYS),
    setDistrictFunding,
    toHasManyAttribute(['detail']),
    update('programs', (programs) =>
      programs ? programs.map(mapAllocations) : []
    ),
    mapAllocations,
    update('partnerships', (partnerships) =>
      partnerships ? partnerships.map(mapAllocations) : []
    ),
    (params) => addSchoolYearToParams(params, schoolYear),
    (params) => convertToNestedAttributes(params, { extraKeys: ['address'] })
  )(partner)
}

export default serializePartnerParams
